/**
 * Swallows the rejection an aborted request produces, and rethrows anything else.
 *
 * Effects that fetch on mount abort in their cleanup. That is correct — and in
 * development React 18's StrictMode mounts, unmounts and remounts every effect,
 * so it happens on every screen. When the async worker is invoked bare
 * (`load()` instead of `load().catch(...)`) the abort surfaces as an unhandled
 * rejection: the console fills up and webpack-dev-server drops its full-screen
 * "Uncaught runtime errors: Fetch is aborted" overlay over the app.
 *
 * Rethrowing everything else keeps real failures exactly as loud as they are
 * today.
 *
 *   useEffect(() => {
 *     const controller = new AbortController();
 *     const load = async () => { ... };
 *     load().catch(ignoreAbort);
 *     return () => controller.abort();
 *   }, []);
 */
export const ignoreAbort = (error) => {
  if (error?.name !== "AbortError") throw error;
};

export default ignoreAbort;
